import { useForm } from "react-hook-form";
import { useEffect } from "react";

export function EmptyEpisodes(props) {
    const { register, handleSubmit, reset } = useForm({
        defaultValues: props.episode
    });

    useEffect(() => {
        reset(props.episode);
    }, [props.episode, reset]);

    const onSubmit = (data) => {
        props.onSaveClicked(data);
    };

    const inputStyle = {
        padding: '8px 10px',
        borderRadius: '8px',
        border: '1px solid #bfdbfe',
        fontSize: '13px',
        outline: 'none',
        boxSizing: 'border-box'
    };

    const labelStyle = {
        fontSize: '11px',
        fontWeight: '700',
        color: '#3b82f6',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap'
    };

    return (
        <div style={{ width: '100%' }}>
            <form onSubmit={handleSubmit(onSubmit)} style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '10px'
            }}>
                {/* Рядок 1: Основна інформація + Кнопка */}
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                    <input
                        {...register('serialOrder')}
                        type="number"
                        placeholder="№"
                        style={{ ...inputStyle, width: '60px', textAlign: 'center' }}
                    />

                    <input
                        {...register('name')}
                        type="text"
                        placeholder="Назва нової серії..."
                        style={{ ...inputStyle, flex: 2 }}
                    />

                    <input
                        {...register('url')}
                        type="text"
                        placeholder="URL відео (Telegram)"
                        style={{ ...inputStyle, flex: 3 }}
                    />

                    <button type="submit" style={{
                        backgroundColor: '#2563eb',
                        color: 'white',
                        border: 'none',
                        padding: '8px 20px',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontWeight: '700',
                        fontSize: '14px',
                        transition: '0.2s',
                        whiteSpace: 'nowrap',
                        height: '37px'
                    }}
                            onMouseOver={(e) => e.target.style.backgroundColor = '#1d4ed8'}
                            onMouseOut={(e) => e.target.style.backgroundColor = '#2563eb'}
                    >
                        Додати
                    </button>
                </div>

                {/* Рядок 2: Додаткові UHD посилання з лейблами */}
                <div style={{ display: 'flex', gap: '12px', alignItems: 'center', paddingLeft: '68px', paddingRight: '98px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flex: 1 }}>
                        <span style={labelStyle}>UHD File:</span>
                        <input
                            {...register('uhdFileUrl')}
                            type="text"
                            placeholder="https://t.me/..."
                            style={{ ...inputStyle, flex: 1, backgroundColor: '#fff' }}
                        />
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flex: 1 }}>
                        <span style={labelStyle}>UHD Video:</span>
                        <input
                            {...register('uhdVideoUrl')}
                            type="text"
                            placeholder="https://t.me/..."
                            style={{ ...inputStyle, flex: 1, backgroundColor: '#fff' }}
                        />
                    </div>
                </div>
            </form>
        </div>
    );
}